import Kfit from '../integrations/Kfit';

export const getAlipayPaymentDetails = id =>
  Kfit.get(`/v5/alipay/${id}`, null).then(res => res);

export const getAlipayVerifyPayment = params =>
  Kfit.get('/v5/alipay/verify_payment', params).then(res => res);
